import PropTypes from 'prop-types';
import React, { useState } from 'react';

import {
    Footer,
    Header,
    HomePageHero,
    Meta
} from '$partials/global/index.js';

import { GlobalLayoutProvider, GlobalLayoutContext } from '$contexts/global-layout.jsx';
import { getAllModules } from '$utilities/data.js';
import ModuleDispatcher from '$partials/modules/dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const HomePage = ({ data, domain }) => {
    const [stylingWhite, setStylingWhite] = useState(true);

    const page = data?.page;

    if (!page) { return null; }

    const modules = getAllModules(page);

    return (
        <>
            <Meta page={page} />

            <main id='main-content'>
                <div className='min-h-screen'>
                    <h1 className='sr-only'>
                        {page.headerTitle}
                    </h1>
                    <GlobalLayoutProvider>
                        <GlobalLayoutContext.Consumer>
                            {() => (
                                <>
                                    <Header
                                        isHomePage={true}
                                        menu={data?.navigation}
                                        setStylingWhite={setStylingWhite}
                                        stylingWhite={stylingWhite} />

                                    <HomePageHero
                                        animatedText={data.page?.animatedText}
                                        headerBackgroundImage={data.page?.headerBackgroundImage}
                                        statistics={data.page?.statistics} />
                                </>
                            )}
                        </GlobalLayoutContext.Consumer>
                    </GlobalLayoutProvider>

                    {/* Content */}
                    {(modules?.length > 0) && (
                        <section>
                            {modules.map((module, i) => {
                                if (!module) { return null; }
                                return (
                                    <ModuleDispatcher
                                        key={i}
                                        module={module}
                                        nextTypename={modules[i + 1]?.__typename}
                                        parent={'Home'}
                                        previousTypename={modules[i - 1]?.__typename} />
                                );
                            })}
                        </section>
                    )}

                    <div className='pt-30 sm:pt-0 md:pt-20'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            headerBackgroundImage: PropTypes.object.isRequired,
            mainText: PropTypes.string.isRequired,
            modules: PropTypes.shape({
                items: PropTypes.array
            }),
            statistics: PropTypes.object
        }),
        footer: PropTypes.shape({
            items: PropTypes.array
        }),
        navigation: PropTypes.object,
    }),
    domain: PropTypes.string,
};

HomePage.propTypes = propTypes;

export default HomePage;
